import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=5ff80cf6&"
import script from "./uploadImg.vue?vue&type=script&lang=js&"
export * from "./uploadImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff80cf6')) {
      api.createRecord('5ff80cf6', component.options)
    } else {
      api.reload('5ff80cf6', component.options)
    }
    module.hot.accept("./uploadImg.vue?vue&type=template&id=5ff80cf6&", function () {
      api.rerender('5ff80cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/staticResource/uploadImg.vue"
export default component.exports